export default {"src":"/_next/static/media/icon_more_treasure.b62bae62.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};